import { draftsApi } from "../store/api/draftsApi";
import { runMutation, runQueryNoArg } from "../store/api/runtime";

interface ApiPayload extends Record<string, unknown> {
  message?: string;
}

export async function fetchDrafts(): Promise<unknown> {
  return runQueryNoArg(draftsApi.endpoints.fetchDrafts.initiate);
}

export async function saveDraft(draftData: ApiPayload): Promise<ApiPayload> {
  return runMutation(draftsApi.endpoints.saveDraft.initiate, draftData);
}

export async function updateDraft(id: string, draftData: ApiPayload): Promise<ApiPayload> {
  return runMutation(draftsApi.endpoints.updateDraft.initiate, { id, draftData });
}

export async function deleteDraft(id: string): Promise<unknown> {
  return runMutation(draftsApi.endpoints.deleteDraft.initiate, id);
}
